// extracted by mini-css-extract-plugin
export var animationContainer = "_aw-0";
export var asteriskIcon = "_aw-8";
export var conversationLeftSection = "_aw-4";
export var conversationListItem = "_aw-3";
export var conversationMiddleSection = "_aw-5";
export var conversationRightSection = "_aw-6";
export var detailsContent = "_aw-1";
export var listContainer = "_aw-7";
export var modalContent = "_aw-2";